import CollectionEditor from "./CollectionEditor"

export default CollectionEditor